<template>
  <div class="tea-page-loading-scope container">
    <slot name="default" />
    <slot name="footer" />
  </div>
</template>

<script lang="ts" setup></script>

<style scoped lang="scss">
.container {
  display: flex;
  flex-direction: column;
  width: 100%;
  min-width: 0;
  max-width: none;
  height: 100%;
  padding: var(--tea-component-page-padding);
  overflow: auto;
  color: var(--tea-component-page-text-color);
  background: var(--tea-component-surface-bg-color);
  background-image: var(--tea-component-surface-bg-image);
  background-size: var(--tea-component-surface-bg-size);
  border: 1px solid var(--tea-component-surface-border-color);
  border-radius: var(--tea-component-surface-radius);
  box-shadow: var(--tea-component-surface-shadow);
  background-blend-mode: var(--tea-component-surface-bg-blend-mode);
  backdrop-filter: var(--tea-component-surface-backdrop-filter);
}
</style>
